import { API_V1 } from 'API/APIs/APIv1';
import _ from 'lodash';
import Logger from 'logger';

export interface UpdatePipelineStatusPayload {
  funnelId: string;
  profileId: string;
  pipeline: 'sales' | 'internalRecruiting' | 'externalRecruiting';
  status: string; // e.g. answered, bookedMeeting, etc.
  value: boolean;
}

export const getAnsweredContacts = async (funnelId: string) => {
  try {
    const response = await API_V1.get('/contact-management/contacts/answered', {
      params: { funnelId },
    });

    const apiData = response.data;
    const normalised = 'response' in apiData ? apiData : { response: apiData };
    if (!('error' in normalised)) (normalised as any).error = null;

    return normalised;
  } catch (e) {
    Logger.trace('Error while fetching answered contacts!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: [] };
  }
};

export const updatePipelineStatus = async (payload: UpdatePipelineStatusPayload) => {
  try {
    const response = await API_V1.put('/contact-management/contacts/pipeline-status', payload);
    return response.data;
  } catch (e) {
    Logger.trace('Error while updating pipeline status!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: null };
  }
};

export const getOverviewAnsweredContacts = async (
  type?: 'socialSelling' | 'recruiting',
  dateFrom?: string,
  dateTo?: string
) => {
  try {
    const response = await API_V1.get('/contact-management/campaigns/answered-contacts', {
      params: {
        ...(type ? { type } : {}),
        ...(dateFrom ? { dateFrom } : {}),
        ...(dateTo ? { dateTo } : {}),
      },
    });

    const apiData = response.data;
    const normalised = 'response' in apiData ? apiData : { response: apiData };
    if (!('error' in normalised)) (normalised as any).error = null;
    return normalised;
  } catch (e) {
    Logger.trace('Error while fetching overview answered contacts!');
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), data: null };
  }
};

export interface PipelineKpiParams {
  type?: 'sales' | 'internalRecruiting' | 'externalRecruiting';
  funnelId?: string;
  dateFrom?: string;
  dateTo?: string;
}

export const getPipelineKpis = async (params: PipelineKpiParams = {}) => {
  try {
    const response = await API_V1.get('/contact-management/pipeline-kpis', {
      params,
    });
    const apiData = response.data;
    const normalised = 'error' in apiData ? apiData : { error: null, response: apiData };
    return normalised;
  } catch (e) {
    Logger.error(e);
    return { error: _.get(e, 'response.data', e), response: {} };
  }
};
